export const academicdata = [
    {
        "id": 1,
        "image": require("../../assets/academic articles/anglo.png"),
        "title": "No Reason Why: Obliteration of Anglo-Indian Representation from the Indian Parliament",
        "description": "In December 2019, the Indian Parliament passed the 126th Constitutional Amendment Bill, 2019 thereby placing the 104th Constitutional Amendment Act 2019." ,
        "publisher": "Law School Policy Review & Kautilya Society",
        "article": "https://lawschoolpolicyreview.com/2020/05/31/no-reason-why-obliteration-of-anglo-indian-representation-from-the-indian-parliament/"
    },

    {
        "id": 2,
        "image": require("../../assets/academic articles/legal.jpg"),
        "title": "The Legal Question of Being an 'Anglo-Indian': Race, Identity, and Law in Colonial India",
        "description": "From colonial times to modern-day independent India, mixed-race groups have struggled to find their existence in a legal context." ,
        "publisher": "Armstrong Undergraduate Journal of History",
        "article": "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4110338"
    }
]
